"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SendSmtpEmailReplyTo1 {
    static getAttributeTypeMap() {
        return SendSmtpEmailReplyTo1.attributeTypeMap;
    }
}
SendSmtpEmailReplyTo1.discriminator = undefined;
SendSmtpEmailReplyTo1.attributeTypeMap = [
    {
        "name": "email",
        "baseName": "email",
        "type": "string"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    }
];
exports.SendSmtpEmailReplyTo1 = SendSmtpEmailReplyTo1;
//# sourceMappingURL=sendSmtpEmailReplyTo1.js.map